import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';

import { LUBRIFICACAO, TRR_CHILE } from '~/constants/modules';
import { t, can } from '~/helpers';

import MyForm from './form';

const formRef = createRef();

class Supply extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      params: {},
      disabled: false,
      title: 'transformarabastecimento',
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  // Close modal
  async handleCloseModal() {
    await this.setState({ open: false });
  }

  async handleChangeTitle(type) {
    if (can(TRR_CHILE)) {
      await this.setState({ title: 'transformarentregaproduto' });
    } else if (type === 'C') {
      await this.setState({ title: 'transformarabastecimento' });
    } else {
      await this.setState({ title: 'transformarlubrificacao' });
    }
  }

  render() {
    const { open, params, disabled, title } = this.state;

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={() => this.handleCloseModal()}
        fullScreen={window.innerWidth <= 450}
      >
        <DialogTitle>{t(`s.operacao.vazaonaoautorizada.${title}`)}</DialogTitle>
        <DialogContent>
          <MyForm
            data={params}
            reference={formRef}
            isLoading={(loading) => this.setState({ disabled: loading })}
            close={() => {
              this.handleCloseModal();
              this.props.update();
            }}
            changeTitle={(value) => this.handleChangeTitle(value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="outlined"
            onClick={() => formRef.current.submitForm()}
            disabled={disabled}
          >
            {t('s.geral.botaoconfirmar')}
          </Button>

          <Button
            startIcon={<Close />}
            color="secondary"
            variant="outlined"
            onClick={() => this.handleCloseModal()}
            disabled={disabled}
          >
            {t('s.geral.botaocancelar')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, null, null, { forwardRef: true })(Supply);
